import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { ApiWaveCreditScope } from "@/generated/models/ApiWaveCreditScope";
import { ApiWaveType } from "@/generated/models/ApiWaveType";
import WaveAuthor from "./WaveAuthor";
import WaveTypeIcon from "./WaveTypeIcon";
import WaveRating from "./WaveRating";
import WaveSlowMode from "./WaveSlowMode";
import WaveDisableLinks from "./WaveDisableLinks";
import WaveApprovalThresholds from "./WaveApprovalThresholds";
const CREDIT_SCOPE_LABELS: Record<ApiWaveCreditScope, string> = {
  [ApiWaveCreditScope.Wave]: "Whole wave",
  [ApiWaveCreditScope.Drop]: "Each drop"
};
interface WaveSpecsProps {
  readonly wave: ApiWave;
  readonly useRing?: boolean | undefined;
}
export default function WaveSpecs(t0) {
  const $ = _c(26);
  const {
    wave,
    useRing: t1
  } = t0;
  const useRing = t1 === undefined ? true : t1;
  const ringClasses = useRing ? "tw-ring-1 tw-ring-inset tw-ring-iron-800 tw-rounded-xl" : "";
  const isChatWave = wave.wave.type === ApiWaveType.Chat;
  const isApproveWave = wave.wave.type === ApiWaveType.Approve;
  const showSlowMode = wave.chat.enabled;
  const creditScope = wave.voting.credit_scope ?? ApiWaveCreditScope.Wave;
  const creditScopeLabel = CREDIT_SCOPE_LABELS[creditScope] ?? CREDIT_SCOPE_LABELS[ApiWaveCreditScope.Wave];
  const t2 = `tw-relative tw-overflow-auto tw-bg-iron-950 ${ringClasses}`;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="tw-flex tw-items-center tw-justify-between tw-px-4 tw-pt-3"><p className="tw-mb-0 tw-text-base tw-font-semibold tw-tracking-tight tw-text-iron-200">General</p></div>;
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <span className="tw-font-medium tw-text-iron-400">Type</span>;
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== wave.wave.type) {
    t5 = <div className="tw-group tw-flex tw-h-6 tw-w-full tw-items-center tw-justify-between tw-gap-1.5 tw-text-sm">{t4}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveTypeIcon waveType={wave.wave.type} /></div></div>;
    $[2] = wave.wave.type;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== creditScopeLabel || $[5] !== isChatWave || $[6] !== wave) {
    t6 = !isChatWave && <><div className="tw-group tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-2 tw-text-sm"><span className="tw-font-medium tw-text-iron-400">Voting</span><div className="tw-flex tw-flex-1 tw-justify-end"><WaveRating wave={wave} /></div></div><div className="tw-group tw-flex tw-h-6 tw-w-full tw-items-center tw-justify-between tw-gap-1.5 tw-text-sm"><span className="tw-font-medium tw-text-iron-400">Voting power</span><span className="tw-self-end tw-font-medium tw-text-iron-200">{creditScopeLabel}</span></div></>;
    $[4] = creditScopeLabel;
    $[5] = isChatWave;
    $[6] = wave;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== isApproveWave || $[9] !== wave) {
    t7 = isApproveWave && <WaveApprovalThresholds wave={wave} />;
    $[8] = isApproveWave;
    $[9] = wave;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="tw-font-medium tw-text-iron-400">Creator</span>;
    $[11] = t8;
  } else {
    t8 = $[11];
  }
  let t9;
  if ($[12] !== wave) {
    t9 = <div className="tw-group tw-flex tw-h-6 tw-w-full tw-items-center tw-justify-between tw-gap-1.5 tw-text-sm">{t8}<div className="tw-flex tw-items-center tw-gap-x-1"><WaveAuthor wave={wave} /></div></div>;
    $[12] = wave;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== showSlowMode || $[15] !== wave) {
    t10 = showSlowMode && <><WaveSlowMode wave={wave} /><WaveDisableLinks wave={wave} /></>;
    $[14] = showSlowMode;
    $[15] = wave;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10 || $[18] !== t5 || $[19] !== t6 || $[20] !== t7 || $[21] !== t9) {
    t11 = <div className="tw-pb-4">{t3}<div className="tw-mt-2.5 tw-flex tw-flex-col tw-gap-2 tw-px-4">{t5}{t6}{t7}{t9}{t10}</div></div>;
    $[17] = t10;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
    $[21] = t9;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== t11 || $[24] !== t2) {
    t12 = <div className={t2}>{t11}</div>;
    $[23] = t11;
    $[24] = t2;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  return t12;
}